import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Table,
  Empty,
  Typography,
  Icon,
  Popconfirm,
  Divider,
  Button,
  message,
} from "antd";
import _ from "lodash";
import { platformApi } from "../../../../../api";
import { formatValue } from "../../../../../utils";
const { Text } = Typography;

function BankDetails({
  form,
  validityRef,
  data,
  clearRef,
  editable,
  values,
  setData,
  error,
  setError,
  setBankDelData,
  delbankData
}) {
  const { getFieldDecorator } = form;
  const [dataSource, setDataSource] = useState([]);
  const [editBank, setEditBank] = useState(null);

  useEffect(() => {
    if (data.bank) {
      setDataSource(data.bank);
    }
    clearRef.current = () => {
      form.resetFields();
    };
    validityRef.current = () => {
      return validatePage();
    };
    return () => {
      validityRef.current = null;
      clearRef.current = null;
    };
  }, []);

  const validatePage = () => {
    return true;
  };

  const addData = () => {
    form.validateFields((validationError) => {
      if (validationError === null && !error.IFSC) {
        let dataObj = form.getFieldsValue();
        if (values && !editBank) {
          dataObj.id = "";
        }
        let dataBank = dataSource;
        if (editBank) {
          let index = -1;
          let originalId = "";
          dataBank.map((e, i) => {
            if (e.id === editBank || e.accountNumber === editBank) {
              index = i;
              originalId = e.id;
            }
          });
          if (index !== -1) {
            dataObj.id = originalId;
            dataBank[index] = dataObj;
          }
          setEditBank(null);
        } else {
          dataBank.push(dataObj);
        }

        setDataSource([]);
        setDataSource(dataBank);
        let dataNew = data;
        dataNew.bank = dataBank;
        setData([]);
        setData(dataNew);
        form.setFieldsValue({
          name: undefined,
          accountName: undefined,
          accountNumber: undefined,
          ifsc: undefined,
        });
      }
    });
  };

  const deleteData = (dataDelete) => {
    if (!dataDelete.id) {
      setDataSource([]);
      const dataBank = dataSource.filter(
        (d) => d.accountNumber !== dataDelete.accountNumber
      );
      setDataSource(dataBank);
      let dataNew = data;
      dataNew.bank = dataBank;
      setData([]);
      setData(dataNew);
    } else {
      let dataBank = dataSource.filter((data) => data.id !== dataDelete.id);
      setDataSource(dataBank);
      setBankDelData([dataDelete])
      let dataNew = data;
      dataNew.bank = dataBank;
      setData([]);
      setData(dataNew);
    }
  };

  const column = [
    {
      title: <Text strong>Bank Name</Text>,
      dataIndex: "name",
      key: "name",
      render: (record) => <span>{record}</span>,
    },
    {
      title: <Text strong>Account Holder</Text>,
      dataIndex: "accountName",
      key: "accountName",
      render: (record) => <span>{record}</span>,
    },
    {
      title: <Text strong>Account Number</Text>,
      dataIndex: "accountNumber",
      key: "accountNumber",
      render: (record) => <span>{record}</span>,
    },
    {
      title: <Text strong>IFSC</Text>,
      dataIndex: "ifsc",
      key: "ifsc",
      render: (record) => <span>{record}</span>,
    },
    {
      title: <Text strong>Action</Text>,
      render: (record) => (
        <div>
          <span>
            <Icon
              onClick={(event) => {
                event.stopPropagation();
                setEditBank(record.id || record.accountNumber);
                form.setFieldsValue({
                  name: record.name,
                  accountName: record.accountName,
                  accountNumber: record.accountNumber,
                  ifsc: record.ifsc,
                });
              }}
              type="edit"
            />
            <Divider type="vertical" />
          </span>
          <Popconfirm
            title="Do you want to delete this Account Number?"
            okText="Yes"
            cancelText="No"
            onCancel={(event) => {
              event.stopPropagation();
            }}
            onConfirm={(event) => {
              event.stopPropagation();
              deleteData(record);
            }}
          >
            <Icon type="delete" onClick={(event) => event.stopPropagation()} />
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div>
      <Table
        tableLayout="fixed"
        locale={{
          emptyText: (
            <Empty
              imageStyle={{ height: 25, fontSize: 30 }}
              description={
                <Text disabled strong>
                  No Accounts
                </Text>
              }
              image={<Icon type="contacts" />}
            />
          ),
        }}
        rowKey={(record) => record.id}
        pagination={false}
        size="small"
        columns={column.filter(
          (columns) => columns.title.props.children !== "Action" || !editable
        )}
        style={{ cursor: "pointer", marginTop: "5vh" }}
        dataSource={dataSource}
      />
      <Form
        style={{
          marginTop: "3vh",
          marginBottom: "3vh",
          display: !editable ? "" : "none",
        }}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              validateStatus={error.BANK && error.BANK.type}
              help={error.BANK && error.BANK.message}
              label="Bank Name">
              {getFieldDecorator("name", {
                rules: [
                  {
                    required: true,
                    message: "Enter your Bank Name!",
                  },
                  {
                    pattern: /^[a-zA-Z.\s]+$/,
                    message: "Special characters are not allowed!",
                  },
                ],
              })(
                <Input
                  onInput={(event) => {
                    event.target.value = event.target.value.replace(/[^a-zA-Z.\s]/g, "");
                    if (!event.target.checkValidity()) {
                      setError({
                        ...error,
                        BANK: {
                          type: "error",
                          message: "Enter Valid Bank Name"
                        }
                      })
                    } else {
                      delete error.BANK
                      setError(error)
                    }
                  }}
                  onKeyUp={e => {
                    const val = e.target.value.replace(/[^a-zA-Z.\s]/g, "");
                    form.setFieldsValue({
                      name: val
                    });
                  }}
                  maxLength={30}
                  placeholder="Bank Name"
                  disabled={editable}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              validateStatus={error.HOLDER && error.HOLDER.type}
              help={error.HOLDER && error.HOLDER.message}
              label="Account Holder Name">
              {getFieldDecorator("accountName", {
                rules: [
                  {
                    required: true,
                    message: "Enter your Account Holder Name!",
                  },
                  {
                    pattern: /^[a-zA-Z.\s]+$/,
                    message: "Special characters are not allowed!",
                  },
                ],
              })(
                <Input
                  onInput={(event) => {
                    event.target.value = event.target.value.replace(/[^a-zA-Z.\s]/g, "");
                    if (!event.target.checkValidity()) {
                      setError({
                        ...error,
                        HOLDER: {
                          type: "error",
                          message: "Enter Valid Account Holder Name"
                        }
                      })
                    } else {
                      delete error.HOLDER
                      setError(error)
                    }
                  }}
                  onKeyUp={e => {
                    const val = e.target.value.replace(/[^a-zA-Z.\s]/g, "");
                    form.setFieldsValue({
                      accountName: formatValue({ target: { value: val } }, "allCaps")
                    });
                  }}
                  maxLength={60}
                  placeholder="Account Holder Name"
                  disabled={editable}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Account Number"
              validateStatus={error.AN && error.AN.type}
              help={error.AN && error.AN.message}
            >
              {getFieldDecorator("accountNumber", {
                rules: [
                  {
                    required: true,
                    message: "Enter your Account Number!",
                  },
                  {
                    pattern: /^[0-9]{9,18}$/,
                    message: "Enter a valid 9 to 18-digit account number",
                  },
                ],
              })(
                <Input
                  onWheel={(event) => event.currentTarget.blur()}
                  placeholder="Account Number"
                  onInput={(event) => {
                    event.target.value = event.target.value.replace(/[^0-9]/g, "");
                    if (!event.target.checkValidity()) {
                      setError({
                        ...error,
                        AN: {
                          type: "error",
                          message: "Enter Valid Account Number",
                        },
                      });
                    } else {
                      delete error.AN;
                      setError(error);
                    }
                  }}
                  onKeyUp={e => {
                    const val = e.target.value.replace(/[^0-9]/g, "");
                    form.setFieldsValue({
                      accountNumber: val
                    });
                  }}
                  disabled={editable}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="IFSC"
              validateStatus={error.IFSC && error.IFSC.type}
              help={error.IFSC && error.IFSC.message}
              colon={false}
              required={true}
            >
              {getFieldDecorator("ifsc", {
                rules: [
                  {
                    required: true,
                    message: "Enter your IFSC!",
                  },
                  {
                    pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                    message: "Enter a valid IFSC",
                  },
                ],
              })(
                <Input
                  placeholder="IFSC"
                  disabled={editable}
                  maxLength={11}
                  onInput={(event) => {
                    const val = event.target.value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
                    event.target.value = val;
                    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
                    if (val.length === 11 && !ifscRegex.test(val)) {
                      setError({
                        ...error,
                        IFSC: {
                          type: "error",
                          message: "Enter Valid IFSC Code",
                        },
                      });
                    } else if (val.length > 0 && val.length < 11) {
                      setError({
                        ...error,
                        IFSC: {
                          type: "error",
                          message: "IFSC must be 11 characters",
                        },
                      });
                    } else {
                      delete error.IFSC;
                      setError(error);
                    }
                  }}
                  onKeyUp={e => {
                    const val = e.target.value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
                    form.setFieldsValue({
                      ifsc: val
                    });
                  }}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Button
          type="primary"
          style={{ marginTop: "5vh" }}
          onClick={() => addData()}
        >
          Save
        </Button>
      </Form>
    </div>
  );
}

const WrappedSubDealerBankForm = Form.create({ name: "SubDealerBankForm" })(
  BankDetails
);
export default WrappedSubDealerBankForm;
